import { VideoData } from '@anm/HostingPlayer';
import InputFile from '@anm/components/InputFile';
import Image from '@anm/components/image/Image';
import SectionTitle from '@anm/components/video-landings/SectionTitle';
import { FC } from 'react';

import vtConfig from '../../../config';

import SuccessNotification from './SuccessNotification';
import {
  PosterBlockContainer,
  PosterBlockWrapper,
  PosterButton,
  PosterButtonsWrapper,
  PosterPreview,
  PosterPreviewImageWrapper,
  Row
} from './Wrapper';
import { usePosterBlock } from './hooks';

export type PosterBlockProps = {
  videoData: VideoData;
  currentTime?: number;
};

const { supportedImageExtensions } = vtConfig();

const allowedExtensionsList = supportedImageExtensions.map(e => `.${e}`).join();

const posterPlaceholder = `images/dashboard/empty_poster.svg`;

const PosterBlock: FC<PosterBlockProps> = ({ videoData, currentTime }) => {
  const isDisabled = !videoData?.sources.length;

  const {
    meta: { name },
    poster,
    bestQualityVideo: videoUrl,
    sizes: { height: posterHeight }
  } = videoData;

  const [uploadCustomPoster, setPosterByFrame, uploadFrameStatus, customUploadStatus] = usePosterBlock({
    poster,
    videoUrl,
    posterHeight,
    currentTime
  });

  return (
    <PosterBlockWrapper>
      <SuccessNotification />
      <SectionTitle level={2} title="Thumbnail" />
      <PosterBlockContainer>
        <PosterPreview>
          <PosterPreviewImageWrapper>
            <Image src={poster?.posterUrl || posterPlaceholder} alt={name} />
          </PosterPreviewImageWrapper>
        </PosterPreview>
        <PosterButtonsWrapper disabled={isDisabled}>
          <Row>
            <PosterButton size="full-width" onClick={setPosterByFrame} variant="silver" isPending={uploadFrameStatus}>
              Use current frame
            </PosterButton>
          </Row>
          <Row>
            <label>
              <PosterButton buttonType="container" size="full-width" variant="silver" isPending={customUploadStatus}>
                Upload thumbnail
              </PosterButton>
              <InputFile disabled={isDisabled} accept={allowedExtensionsList} handleUpload={uploadCustomPoster} />
            </label>
          </Row>
        </PosterButtonsWrapper>
      </PosterBlockContainer>
    </PosterBlockWrapper>
  );
};

export default PosterBlock;
